/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-23T13:19:12-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, borders, type, textColor } from '../../style';

const style = StyleSheet.create({
  menuList: {
    margin: '0',
    padding: '0',
    listStyle: 'none'
  },

  listItem: {
    margin: '0',
    padding: '0'
  },

  center: {
    textAlign: 'center'
  },

  bordered: {
    borderBottom: borders.DEFAULT,

    [':last-child']: {
      borderBottomWidth: '0'
    }
  }
})



const MenuList = (props) => {

  return (
    <ul className={css(style.menuList)}>
      {props.children}
    </ul>
  )
}

const MenuListItem = (props) => {

  let {
    centered
  } = props

  return (
    <li className={css(style.listItem, centered && style.center, style.bordered)}>
      {props.children}
    </li>
  )
}

export {MenuList, MenuListItem};



// WEBPACK FOOTER //
// ./src/components/blocks/MenuList.jsx